function TopBar({title}) {

const username =
localStorage.getItem(
"username"
);

const email =
localStorage.getItem(
"email"
);

return(

<nav
className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm px-3 py-2 mb-0"
>

<div className="container-fluid">

<div className="navbar-brand fw-bold">

SaleUpCall

</div>

<div
className="ms-auto text-end"
>

<div
className="fw-bold"
>

<i className="bi bi-person-circle me-2"></i>

{username}

</div>

<small
className="text-muted"
>

{email}

</small>

</div>

</div>

</nav>

);

}

export default TopBar;